import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  // Helps catch a missing .env during local dev / build.
  // eslint-disable-next-line no-console
  console.warn(
    'Supabase env vars are missing. Set REACT_APP_SUPABASE_URL and ' +
      'REACT_APP_SUPABASE_ANON_KEY in your .env file.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Recovery links use the implicit flow (tokens in the URL hash). We parse
    // the hash ourselves in ResetPassword via setSession(), so we disable the
    // built-in detector to avoid it racing/consuming the token first.
    flowType: 'implicit',
    detectSessionInUrl: false,
    persistSession: true,
    autoRefreshToken: true,
  },
});
